import RootStore from "@stores/RootStore";
import { getLocalStorageItem, setLocalStorageItem } from "@utils/localStorageUtil";
import { AxiosError } from "axios";
import { action, makeObservable, observable } from "mobx";
import City from "../models/City";
import CityService from "../services/CityService";

export default class CityStore {
    rootStore: RootStore;
    service: CityService;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
        this.service = new CityService();

        makeObservable(this, {
            //#region UI
            isLoading: observable,
            setIsLoading: action,
            //#endregion

            initializeSelectedCity: action,
            cities: observable,
            selectedCity: observable,
            findAsync: action,
            onCityChange: action,
        })

        this.initializeSelectedCity();
    }

    //#region UI

    isLoading: boolean = false;
    setIsLoading = (value: boolean) => {
        this.isLoading = value
    }

    //#endregion


    initializeSelectedCity = () => {
        var serializedCityFromLocalStorage = getLocalStorageItem("selectedCity");

        var city: City = this.createDefaultCity();
        if (serializedCityFromLocalStorage === undefined || serializedCityFromLocalStorage === null) {
            city = this.createDefaultCity();
        }
        else {
            var parsedCityFromLocalStorage = JSON.parse(serializedCityFromLocalStorage) as City;
            if (parsedCityFromLocalStorage.id === undefined || parsedCityFromLocalStorage.id === null) {
                city = this.createDefaultCity();
            }
            else {
                parsedCityFromLocalStorage.isSelected = true;
                city = parsedCityFromLocalStorage;
            }

        }

        this.selectedCity = city;
    }

    cities: City[] = [];
    selectedCity: City;

    findAsync = async () => {
        this.setIsLoading(true);

        try {
            var response = (await this.service.findAsync()).data;
            this.cities = response.item;
        } catch (error) {
            if (error instanceof AxiosError) {

            }
        }
        finally {
            this.setIsLoading(false);
        }
    }

    onCityChange = (city: City) => {
        this.selectedCity = city;
        this.saveCityToLocalStorage(city);
        this.rootStore.restaurantOfferStore.getRestaurantsAsync();
    }

    saveCityToLocalStorage = (city: City) => {
        setLocalStorageItem(
            "selectedCity",
            JSON.stringify({ id: city.id, name: city.name })
        );
    };

    createDefaultCity = () => {
        var defaultCityId = process.env.REACT_APP_DEFAULT_CITY_ID;
        var defaultCityName = process.env.REACT_APP_DEFAULT_CITY_NAME;

        if (defaultCityId === undefined || defaultCityName === undefined) {
            console.log("Default city is missing!");
            return {} as City;
        }

        var defaultCity: City = {
            id: defaultCityId,
            name: defaultCityName,
            isSelected: true,
            dateCreated: new Date,
            dateEdited: new Date
        }

        return defaultCity;
    }
}